import {AMBROSIA_URL} from '../../helpers/auth-header'
import Axios from 'axios'

export default {
    
    /**
	 *
	 * @param commit
	 * @param dispatch
	 * @param event
	 */
    EditCustomer({commit,dispatch}, e){
        let postData = {
            firstNames:e.target.name.value,
            lastNames: e.target.lastName.value,
            birthday: e.target.birthday.value,
            phone: e.target.phone.value,
            mobile: e.target.mobile.value,
            email:e.target.email.value,
            password: e.target.password.value,
            passwordConfirmation:e.target.passwordConfirmation.value,
        }
        Axios.post(AMBROSIA_URL + '/web/update-customer',postData)
        .then(response => {
            dispatch('ShowToast', { 'icon':'success', 'title':'Se modificaron sus datos'})
            commit('StateAssign', { currentCustomer: response.data.data })
            const currentCustomer = ['currentCustomer='+ JSON.stringify(response.data.data)]
            document.cookie = currentCustomer
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title':'Error al modificaron datos'})
        })
    },

    /**
	 *
	 * @param commit
	 * @param dispatch
	 * @param event
	 */
    EditAddress({commit,dispatch}, e){
        let postData = {
            latitude:e.target.latitude.value,
            longitude:e.target.longitude.value,
            street:e.target.street.value,
            number: e.target.number.value,
            interiorNumber: e.target.interiorNumber.value,
            neighborhoodId: '56dbf16c-6635-11e6-ac52-06e0cabe8fd1',
            referenceStreets:e.target.referenceStreets.value,
            comments: e.target.comments.value
        }
        Axios.post(AMBROSIA_URL + '/web/create-address',postData)
        .then(response => {
            dispatch('ShowToast', { 'icon':'success', 'title':'Se agrego direccion'})
            dispatch('GetUserAddresses')
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title':'Error al agregar direccion'})
        })
    },

    /**
	 * Fetches the current customer set by localstorage authtoken
     *
	 * @param state
     * @param dispatch
	 */
    GetCurrentCustomer({state, dispatch}){
        // -- See if there is a customer token currently set
        let customerToken = localStorage.getItem( 'authToken' )

        // -- If not, return and dont fetch customer
        if( !customerToken ) return;

        // -- Fetch current customer
        Axios.get( AMBROSIA_URL+ '/authorization/current-customer')
        .then( r => {
            dispatch('SetCustomer', r.data.data)
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title':'Error al obtener direccion'})
        })
    },

    /**
	 *
	 * @param state
	 */
    GetUserAddresses({state,dispatch}){
        Axios.get(AMBROSIA_URL+'/web/get-address')
        .then(response => {
            state.currentCustomerAddresses = response.data.data
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title':'Error al obtener direccion'})
        })
    },

    /**
	 * Get user orders
	 * @param state
     * @param dispatch
	 */
    GetUserOrders({state,dispatch}){
        if(state.currentCustomer) {
            Axios.get(AMBROSIA_URL+'/web/get-user-orders')
            .then(response => {
                if(response.data.data && response.data.data.length>0){
                    state.userOrders = response.data.data
             }
            })
            .catch(error => {
                dispatch('ShowToast', { 'icon':'error', 'title':'Error al obtener ordenes'})
            })
        }
    },

    /**
	 *Get favorite user products
	 * @param state
     * @param dispatch
	 */
    GetFavorites({state,dispatch}){
        if(state.currentCustomer){
            Axios.get(AMBROSIA_URL+'/web/get-favorites')
            .then(response =>{
                state.userFavorites = response.data.data
             })
            .catch(error => {
                dispatch('ShowToast', { 'icon':'error', 'title':'Error al obtener botiquín'})
            })
        }
    },

     /**
	 *Delete user address
	 * @param state
     * @param dispatch
     * @param addressId
	 */
    DeleteAddress({state,dispatch},addressId){
        let postData = {
            addressId: addressId
        }
        Axios.post(AMBROSIA_URL+'/web/delete-address',postData)
        .then(response => {
            dispatch('GetUserAddresses')
            dispatch('ShowToast', { 'icon':'success', 'title':'Se ha eliminado la dirección'})
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title':'Error al eliminar direccion'})
        })
    },

     /**
	 *Delete favorite product
     * @param dispatch
     * @param favoriteId
	 */
    DeleteToFavorite({dispatch},favoriteId){
        let postData = {
            favoriteId:favoriteId
        }
        Axios.post(AMBROSIA_URL+'/web/delete-favorite',postData)
        .then( response => {
            dispatch('ShowToast', { 'icon':'success', 'title':'Se ha eliminado producto de botiquín'})
        }
        )
        .catch( error =>{
            dispatch('ShowToast', { 'icon':'error', 'title':'Error al eliminar producto de botiquín'})
        }
        )
    },
     /**
	 *
	 * @param state
	 */
    OpenProfile({state,dispatch},profile){
        state.prof = profile
        dispatch('RouterPush','mi-perfil')
    }
}